import React from 'react';

const QuoteIcon = () => (
  <svg width="26" height="39" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 26 39">
    <g fill="#000" fillRule="evenodd">
      <path d="M19.637 6.943L0 23.42v-9.137L16.18.706l3.457 6.237zM25.286 17.135L0 38.353v-9.138l21.83-18.317 3.456 6.237z" />
    </g>
  </svg>
);

export default QuoteIcon;
